import { useRef } from "react";
import { LuUser } from "react-icons/lu";
import IconButton from "../buttons/IconButton";
import { Menu } from "primereact/menu";
import { useNavigate } from "react-router-dom";
import useChatbotConfig from "../../hooks/useChatbotConfig";
import { FaUser } from "react-icons/fa";

const UserPanel = ({
  toggleResponsive,
  logout,
  toggleDarkMode,
  handletoggleDarkMode,
}) => {
  const userMenu = useRef(null);
  const navigate = useNavigate();
  const { user, userRole } = useChatbotConfig();

  let items = [
    {
      label: "Panel de Administrador",
      icon: "pi pi-cog",
      command: () => {
        navigate("/admin/bots");
      },
    },
    {
      label: toggleDarkMode ? "Desactivar Tema Oscuro" : "Activar Tema Oscuro",
      icon: toggleDarkMode ? "pi pi-moon" : "pi pi-moon",
      command: () => {
        handletoggleDarkMode();
      },
    },
    {
      label: "Editar Usuario",
      icon: "pi pi-user-edit",
      command: () => {
        navigate("/settings/user");
      },
    },
    {
      label: "Cerrar Sesión",
      icon: "pi pi-sign-out",
      command: () => {
        logout();
      },
    },
  ];
  const itemsFiltered = user?.admin
    ? items
    : items.filter((item) => item.label !== "Panel de Administrador");
  return (
    <>
      <div
        className={
          !toggleResponsive ? "user-link" : "user-link open-responsive"
        }
      >
        <div className="user-row">
          <div className="icon-col">
            <FaUser className="user-icon" />
          </div>
          <div className="name-col ms-3">
            <p className="user-name text-ellipsis" title={user?.name}>
              {user?.name}
            </p>
            <p className="user-subtitle text-ellipsis" title={userRole?.name}>
              {userRole?.name}
            </p>
          </div>
          <div className="opt-col pe-3">
            <IconButton
              icon="ellipsis-v"
              color="secondary"
              text
              handleClick={(event) => userMenu.current.toggle(event)}
            />
            
            <Menu model={itemsFiltered} popup ref={userMenu} />
          </div>
        </div>
      </div>
    </>
  );
};

export default UserPanel;
